import React        from 'react';
import PropTypes    from 'prop-types';
import ReloadHelper from '../../../utils/ReloadHelper';

class Category extends React.Component {
    constructor(props) {
		super(props);
		this.onClick = this.onClickHandler.bind(this);
	}

	/**
	 * @param {Event} e
	 * @returns {*|void}
	 */
	onClickHandler(e) {
		return ReloadHelper.reload(this.props.url, e);
	}

	render() {

		const title = <span dangerouslySetInnerHTML={{__html: this.props.title}} />;

		return (
			<a href={this.props.url} className="video-jumbotron__foreground-category" onClick={this.onClick}>
				<picture>
					<img src={this.props.image} loading={this.props.lazyImageLoading ? 'lazy' : 'eager'}/>
				</picture>
				<div className="video-jumbotron__foreground-category__content">
					<h3 className="video-jumbotron__foreground-category__link">
						<i className="icon -icon-play-rounded-line">&nbsp;</i> {title}
					</h3>
					<small className="video-jumbotron__foreground-category__meta">{this.props.subTitle}</small>
				</div>
			</a>
		);
	}
}

Category.propTypes = {
	title:            PropTypes.string,
	subTitle:         PropTypes.string,
	image:            PropTypes.string,
	url:              PropTypes.string,
	lazyImageLoading: PropTypes.bool,
};

Category.defaultProps = {
	lazyImageLoading: false,
};

export default Category;
